import React, { Children, ReactElement } from 'react';
import { Cell } from '../grid/Cell';
import { Grid } from '../grid/Grid';
import styles from './RadioGroup.module.scss';

export const RadioGroup = ({ label, children, className }: Props) => {

    return (
        <>
            {label && <h6 className={styles.label}>{label}</h6>}
            <Grid className={className} gap='s' align='stretch' justify='start' direction='row' wrap>
                {Children.map(children, child => (
                    <Cell key={child.props.value} className={styles.cell}>
                        {child}
                    </Cell>
                ))}
            </Grid>
        </>
    );
};

type Props = {
    label?: string;
    children: ReactElement[];
    className?: string;
};